import { useState, useEffect } from 'react';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import Api from '../api/api';
import stringHelpers from '../../utilities/stringHelpers';
import formUtilities from '../../utilities/formUtilities';
import Loader from '../shared/loader';
import { ErrorModal } from '../../utilities/errorModal';
import { AppealSupplementaryResponseDisplay } from './appealSupplementaryResponseDisplay';

export const AppealSupplementaryResponse = ({ organisationId, token }) => {
    const { responseId } = useParams()
    const history = useHistory()
    const location = useLocation()
    const returnUrl = `/organisation/${ organisationId }/appeal-supplementary-responses`
    const isNew = stringHelpers.isNullOrEmpty(responseId)
    const [isInEdit, setIsInEdit] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [appealSupplementaryResponse, setAppealSupplementaryResponse] = useState(null)
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [name, setName] = useState("")
    const [content, setContent] = useState("")
    const [errorMessage, setErrorMessage] = useState(null)

    const getAppealSupplementaryResponse = () => {
        Api.getAppealSupplementaryResponse(
            data => {
                setAppealSupplementaryResponse(data)
                setName(data.name)
                setContent(data.content)
                setIsLoading(false)
            },
            error => {
                console.log(error)
                setIsLoading(false)
            },
            responseId,
            organisationId, token
        )
    }

    const submit = () => {
        setIsLoading(true)
        if (!isNew) {
            Api.editAppealSupplementaryResponse(
                data => {
                    if (data.isError) {
                        setErrorMessage(data.errorMessage)
                    } else {
                        setIsInEdit(false)
                        getAppealSupplementaryResponse()
                    }
                    setIsLoading(false)
                },
                error => {
                    console.log(error)
                    setErrorMessage(error.errorMessage)
                    setIsLoading(false)
                },
                responseId,
                name,
                content,
                organisationId,
                token
            )
        } else {
            Api.addAppealSupplementaryResponse(
                data => {
                    if (data.isError) {
                        setErrorMessage(data.errorMessage)
                        setIsLoading(false)
                    } else {
                        history.push(`/organisation/${ organisationId }/appeal-supplementary-response/${ data.id }`)
                    }
                },
                error => {
                    console.log(error)
                    setErrorMessage(error.errorMessage)
                    setIsLoading(false)
                },
                name,
                content,
                organisationId,
                token
            )
        }
    }

    const handleDelete = () => {
        Api.deleteAppealSupplementaryResponse(
            data => {
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                } else {
                    history.push(returnUrl)
                }
            },
            error => {
                console.log(error)
                setErrorMessage(error.message)
            },
            responseId,
            organisationId, token
        )
    }

    const handleCancel = () => {
        if (isNew) {
            history.push(returnUrl)
        } else {
            setIsInEdit(false)
        }
    }

    useEffect(() => {
        if (isNew) {
            setIsInEdit(true)
        } else {
            setIsInEdit(false)
            setIsLoading(true)
            getAppealSupplementaryResponse()
        }
        if (location && location.state !== undefined && location.state.editMode !== undefined) {
            setIsInEdit(location.state.editMode)
        }
    }, [location])

    const detailsHeading = isNew ? "Add new appeal supplementary response" : "Appeal supplementary response -"
    const isConfirmDisabled = stringHelpers.isNullOrEmpty(name) || stringHelpers.isNullOrEmpty(content)

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="card mb-3">
                        {
                            <div className="card-header">
                                <div className="row align-items-center">
                                    <div className="col">
                                        <h5 className="mb-0 d-flex align-items-center">
                                            { detailsHeading } <p className="ml-2 mb-0">{ appealSupplementaryResponse?.name }</p></h5>
                                    </div>
                                    <button className="btn btn-falcon-default btn-sm mr-3 py-1" type="button" onClick={ () => history.push(returnUrl) }>
                                        <i className="fas fa-reply mr-1"></i>Back
                                    </button>
                                    { !isNew &&
                                        <>
                                            <button type="button" className="btn btn-primary btn-sm mr-3" onClick={ () => setIsInEdit(!isInEdit) }>
                                                <i className="fas fa-edit"></i> Edit
                                            </button>
                                            <button className="btn btn-falcon-default btn-sm dropdown-toggle py-2 mr-3 dropdown-caret-none" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"><i className="fas fa-ellipsis-h"></i></button>
                                            <div className="dropdown-menu dropdown-menu-right" x-placement="bottom-start">
                                                <button onClick={ () => setShowDeleteModal(true) } className="dropdown-item text-danger">
                                                    <i className="fas fa-times mr-1"></i>Delete Supplementary Response</button>
                                            </div>
                                        </>
                                    }
                                </div>
                            </div> }
                        {
                            isLoading
                                ? <Loader />
                                : isInEdit
                                    ? <>
                                        <div className="card-body bg-light border-top details-container">
                                            <div className="row mb-1">
                                                <div className="col-md-3 col-12">
                                                    <p className="font-weight-semi-bold mt-1 mb-1">Name<span className="req"></span></p>
                                                </div>
                                                <div className="col-md-6 col-12">
                                                    <div className="form-group mb-0">
                                                        <input required className="form-control mb-0" type="text" value={ name } onChange={ e => {
                                                            setName(e.target.value)
                                                            formUtilities.requiredField(e.target.parentNode, e.target.value)
                                                        } } />
                                                        <small className='invalid-feedback text-danger'>Please enter a name</small>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-3 col-12">
                                                    <p className="font-weight-semi-bold mt-1 mb-1">Content<span className="req"></span></p>
                                                </div>
                                                <div className="col-md-6 col-12">
                                                    <div className="form-group mb-1">
                                                        <textarea required className="form-control mb-0" rows={ 6 } value={ content } onChange={ e => {
                                                            setContent(e.target.value)
                                                            formUtilities.requiredField(e.target.parentNode, e.target.value)
                                                        } } />
                                                        <small className='invalid-feedback text-danger'>Please enter content</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-footer border-top">
                                            <div className="row client-edit-buttons">
                                                <div className="col-12 col-sm-auto ml-auto pl-0">
                                                    <div id="dashboard-actions">
                                                        <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={ handleCancel }>
                                                            <i className="fas fa-times mr-1"></i>
                                                            Cancel
                                                        </button>
                                                        <button disabled={ isConfirmDisabled } type="button" className="btn btn-success btn-sm ml-2" onClick={ () => submit() }>
                                                            <i className="fas fa-check mr-1"></i>
                                                            Confirm
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                    : appealSupplementaryResponse && <AppealSupplementaryResponseDisplay appealSupplementaryResponse={ appealSupplementaryResponse } />
                        }
                    </div>
                </div>
            </div>
            { !stringHelpers.isNullOrEmpty(errorMessage) && <ErrorModal message={ errorMessage } onHide={ () => setErrorMessage(null) } /> }
            {
                showDeleteModal && 
                <Modal show onHide={ () => setShowDeleteModal(false) } centered>
                    <Modal.Header>
                        <Modal.Title className="d-flex gap-2 align-items-center text-danger">Delete Supplementary Response</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="font-weight-semi-bold mt-1 mb-2">Are you sure you want to delete <b>{ name }</b>?</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={ () => setShowDeleteModal(false) }>Cancel</button>
                        <button type="button" className="btn btn-danger btn-sm ml-2" onClick={ () => {
                            setShowDeleteModal(false)
                            handleDelete()
                        } }>Delete</button>
                    </Modal.Footer>
                </Modal>
            }
        </div>
    )
}
